import { apiClient } from '@shared/api/client';
import { ApiResponse } from '@shared/api/api.types';
import { SurveyDTO, CreateSurveyDTO, UpdateSurveyDTO } from '../dtos';

// Survey Management API
export const surveyApi = {
  // Get survey by ID
  async getSurvey(surveyId: string): Promise<ApiResponse<SurveyDTO>> {
    return apiClient.get<SurveyDTO>(`/surveys/${surveyId}`);
  },

  // Get surveys by subject
  async getSurveysBySubject(subjectId: string): Promise<ApiResponse<SurveyDTO[]>> {
    return apiClient.get<SurveyDTO[]>(`/subjects/${subjectId}/surveys`);
  },

  // Get surveys by tenant
  async getSurveysByTenant(tenantId: string): Promise<ApiResponse<SurveyDTO[]>> {
    return apiClient.get<SurveyDTO[]>(`/tenants/${tenantId}/surveys`);
  },

  // Create survey
  async createSurvey(data: CreateSurveyDTO): Promise<ApiResponse<SurveyDTO>> {
    return apiClient.post<SurveyDTO>('/surveys', data);
  },

  // Update survey
  async updateSurvey(surveyId: string, data: UpdateSurveyDTO): Promise<ApiResponse<SurveyDTO>> {
    return apiClient.put<SurveyDTO>(`/surveys/${surveyId}`, data);
  },

  // Delete survey
  async deleteSurvey(surveyId: string): Promise<ApiResponse<void>> {
    return apiClient.delete<void>(`/surveys/${surveyId}`);
  },

  // Close survey (DRAFT/ACTIVE → CLOSED)
  async closeSurvey(surveyId: string): Promise<ApiResponse<SurveyDTO>> {
    return apiClient.post<SurveyDTO>(`/surveys/${surveyId}/close`, {});
  },

  // Reopen survey (CLOSED → DRAFT)
  async reopenSurvey(surveyId: string): Promise<ApiResponse<SurveyDTO>> {
    return apiClient.post<SurveyDTO>(`/surveys/${surveyId}/reopen`, {});
  },

  // Publish survey (DRAFT → ACTIVE)
  async publishSurvey(surveyId: string): Promise<ApiResponse<SurveyDTO>> {
    return apiClient.post<SurveyDTO>(`/surveys/${surveyId}/publish`, {});
  },

  // Set survey to draft (ACTIVE → DRAFT)
  async setToDraft(surveyId: string): Promise<ApiResponse<SurveyDTO>> {
    return apiClient.post<SurveyDTO>(`/surveys/${surveyId}/set-to-draft`, {});
  },
};
